module.exports = __webpack_public_path__ + "static/media/reward-a.a3ff645a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-a.png
// module id = 1867
// module chunks = 0